(() => {
  const CART_SCOPE_SELECTOR = '.cart-totals, .cart-drawer__summary, .cart-page__summary';

  const normaliseText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const removeRedundantGiftAccordions = (scope) => {
    scope.querySelectorAll('summary').forEach((summary) => {
      if (summary.closest('.petal-cart-gifting')) return;
      if (normaliseText(summary.textContent || '') !== 'gift options') return;

      const details = summary.closest('details');
      if (!details) return;

      const accordion = details.closest('accordion-custom-component');
      (accordion || details).remove();
    });
  };

  const deduplicateCustomPanels = (scope) => {
    const panels = [...scope.querySelectorAll('.petal-cart-gifting')];
    panels.slice(1).forEach((panel) => panel.remove());
  };

  const cleanCartGiftOptions = () => {
    document.querySelectorAll(CART_SCOPE_SELECTOR).forEach((scope) => {
      removeRedundantGiftAccordions(scope);
      deduplicateCustomPanels(scope);
    });
  };

  let scheduled = false;
  const scheduleClean = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      cleanCartGiftOptions();
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleClean);
  document.addEventListener('shopify:section:load', scheduleClean);
  document.addEventListener('cart:update', scheduleClean);

  new MutationObserver(scheduleClean).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
